module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"is corporate":"Is corporate","company name":"Company name","salutation":"Salutation","first name":"First name","last name":"Last name"},"de":{"is corporate":"Ist Firma","company name":"Firmenname","salutation":"Anrede","first name":"Vorname","last name":"Nachname"}}')
  delete Component.options._Ctor
}
